var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressLevel3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffe600;}.cls-2{fill:#84680f;}.cls-3{fill:#4d4d4d;stroke:#84680f;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,585A285,285,0,0,1,98.47,98.47,285,285,0,0,1,501.53,501.53,283.17,283.17,0,0,1,300,585Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,30A270.08,270.08,0,0,1,405.09,548.79,270.07,270.07,0,0,1,194.91,51.21,268.16,268.16,0,0,1,300,30m0-30C134.31,0,0,134.31,0,300S134.31,600,300,600,600,465.69,600,300,465.69,0,300,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 146,
    y1: 390,
    x2: 446,
    y2: 390
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 226,
    cy: 233.35,
    rx: 25,
    ry: 42.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 374,
    cy: 233.35,
    rx: 25,
    ry: 42.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressLevel3);
export default __webpack_public_path__ + "static/media/stress_level_3.91a49dafe5cf7dad9ebcf27625f72b83.svg";
export { ForwardRef as ReactComponent };